/**
 * Shared gateway reachability — avoids false "Offline" on refresh when the gateway
 * is busy (Run 12 agent, execution poll) but still serving traffic.
 */

const STORAGE_KEY = "ead-expui.gateway-last-ok.v1";
const GRACE_MS = 90_000;
const OFFLINE_AFTER_MS = 180_000;

let lastSuccessAt = loadLastSuccessAt();
let consecutiveFailures = 0;

function loadLastSuccessAt(): number {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const n = raw ? Number(raw) : 0;
    return Number.isFinite(n) && n > 0 ? n : 0;
  } catch {
    return 0;
  }
}

function persistLastSuccessAt(ts: number): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, String(ts));
  } catch {
    /* ignore */
  }
}

export function recordGatewaySuccess(): void {
  lastSuccessAt = Date.now();
  consecutiveFailures = 0;
  persistLastSuccessAt(lastSuccessAt);
}

export function recordGatewayFailure(): void {
  consecutiveFailures += 1;
}

/** True when a recent request succeeded or we have not exceeded the failure window. */
export function isGatewayReachable(): boolean {
  const now = Date.now();
  if (lastSuccessAt > 0 && now - lastSuccessAt < GRACE_MS) {
    return true;
  }
  if (lastSuccessAt > 0 && now - lastSuccessAt < OFFLINE_AFTER_MS && consecutiveFailures < 10) {
    return true;
  }
  return false;
}

export function hasGatewayEverSucceeded(): boolean {
  return lastSuccessAt > 0;
}
